/**
 * @generated SignedSource<<67baf9ac1bad407f9bb2c5ff51927a0b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PositionApplicationStatusFilter = {
  isActive?: boolean | null | undefined;
  isApproved?: boolean | null | undefined;
  isDisapproved?: boolean | null | undefined;
};
export type PositionApplicationStatusSelectFieldQuery$variables = {
  filters?: PositionApplicationStatusFilter | null | undefined;
};
export type PositionApplicationStatusSelectFieldQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PositionApplicationStatusSelectField_query">;
};
export type PositionApplicationStatusSelectFieldQuery = {
  response: PositionApplicationStatusSelectFieldQuery$data;
  variables: PositionApplicationStatusSelectFieldQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filters"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "filters"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PositionApplicationStatusSelectFieldQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "PositionApplicationStatusSelectField_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PositionApplicationStatusSelectFieldQuery",
    "selections": [
      {
        "alias": "statuses",
        "args": (v1/*: any*/),
        "concreteType": "PositionApplicationStatus",
        "kind": "LinkedField",
        "name": "positionApplicationStatuses",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "position",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d6eb081a3ec669f221f5b16abcf171d7",
    "id": null,
    "metadata": {},
    "name": "PositionApplicationStatusSelectFieldQuery",
    "operationKind": "query",
    "text": "query PositionApplicationStatusSelectFieldQuery(\n  $filters: PositionApplicationStatusFilter\n) {\n  ...PositionApplicationStatusSelectField_query_VTAHT\n}\n\nfragment PositionApplicationStatusSelectField_query_VTAHT on Query {\n  statuses: positionApplicationStatuses(filters: $filters) {\n    id\n    status\n    position\n  }\n}\n"
  }
};
})();

(node as any).hash = "fa2dc20c0a47f4789e5a90974cf57851";

export default node;
